// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3aJU8","box":"WorkspacesBox_box__3xbhh","node":"WorkspacesBox_node__3z2eM"};